module.exports = __webpack_public_path__ + "static/media/highlightdo.83ce90ab.png";